import { useEffect, useState } from "react";
import { GoArrowSwitch } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";

import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import SyncButton from "../../../components/SyncButton/SyncButton";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import FormAccessPoints from "../FormAccessPoints/FormAccessPoints";
import ListAccessPoints from "../ListAccessPoints/ListAccessPoints";
import { useTranslation } from "react-i18next";

const ConsultaAccessPoints = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const { selectedCondominio } = useUserStore();
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);
	const { t } = useTranslation();

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<GoArrowSwitch size={20} />}
					title={t("equipment.accessPoints")}
					buttonLabel={t("equipment.addAccess")}
					onClickAddButton={() =>
						navigate("../cadastro-access-points")
					}
					aditionalButton1={
						<SyncButton
							type={"accessPoint"}
							selectedCondominio={selectedCondominio}
						/>
					}
				>
					<SearchInput
						value={searchText}
						placeholder={t("equipment.searchAccessPoint")}
						onChange={({ target }) => {
							setSearchText(target.value);
							setFilters(target.value);
						}}
						onKeyPress={(e) =>
							e.key === "Enter" && setFilters(searchText)
						}
					/>
				</SearchContainer>

				<Container>
					<ListAccessPoints
						filters={filters}
						refreshKey={refreshKey}
					/>
				</Container>
			</div>

			<ConsultaFormContainer>
				<FormAccessPoints
					accessPoint={lineSelected}
					formMode="consulta"
				/>
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaAccessPoints;